// @ vendors
import { getViewNameByStatus } from 'actions/getViewNameByStatus';

const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');
import { history } from 'routes/history';
// @ actions
const promotionalCodeAction = require('actions/promotionalCodeAction');
const productsActions = require('actions/productsActions');
const formActions = require('react-redux-form').actions;
const wealthProductActions = require('actions/wealthProductActions');
const scoringActions = require('actions/scoringActions');
const suitabilityActions = require('actions/RASuitabilityTest');
const checkStatusActions = require('actions/RACheckStatus');
const preLoaderActions = require('./preLoaderActions');
const raSetGoalActions = require('actions/RASetGoal');
// @ utilities
const StringHelper = require('utilities/stringHelper');
const Storage = require('utilities/storage');
const tools = require('utilities/tools');
import { formatText } from 'core/i18n';

const { getReferenceCodeByCountry } = require('utilities/multiLanguageHelper');
// @ constants
const actionTypes = require('constants/actionTypes');
import { ONB_BANK_DEPOSIT_OPEN } from 'constants/onboardingTypes';

const { BASE_PATH, ALLOW_COOKIE } = require('constants/index');
const optionsActions = require('actions/optionsActions');
import {
    DEBIT_CARD,
    DEBIT_CARD_PIN,
    DOCUMENTATION,
    PRE_DOCUMENTATION,
    STAND_BY,
    SUCCESS,
    SIGNED,
    CONTRACT,
    COMPLETED,
    ACTIVATED,
    WAITING,
    LIMIT_CREDIT,
    LIMIT_CREDIT_INE,
    EXTERNAL_IBAN,
    FIOC,
    IDENTIFICATION,
    IDENTIFIED,
    IDENTIFICATION_ABORTED,
    IDENTIFICATION_ROBO,
    IDENTIFIED_ROBO,
    TRANSFER_OTP,
    PENDING_OTP,
    SIGNATURE_KEY,
    REGISTER_STATUS,
    DEPOSIT_CONFIG_STATUS,
    ADDITIONAL_STATUS,
    OBJECTIVES_SELECTION_STATUS,
    SUITABILITY_TEST_STATUS,
    SIMULATION_STATUS,
    CARD_CONFIG_STATUS,
    READY_STATUS,
    JAFFAR_STATUS,
    BATCH_STATUS,
    CREATED_STATUS,
    UPDATING_DOCUMENTATION_STATUS,
    PRE_CANCELLED_STATUS,
    CANCELLED_STATUS,
} from 'constants/statusProcess';

const { DEBIT } = require('constants/products');
const { FIXED_PAYMENT_METHOD_VALUE, VARIABLE_PAYMENT_METHOD_VALUE } = require('utilities/paymentMethodHelper');
const { ROBO, GBI, CREDIT_CARD, ROBO_REJECTED, GBI_REJECTED, TRADITIONAL, LOAN } = require('constants/userProfile');
import { BASIC as PARTNER_BASIC, VF as PARTNER_VF, EH as PARTNER_EH } from 'constants/creditCard/partners';
import { mapVideocallStatus } from 'utilities/video/videoStatusMapper';
import { LOAN_PATH } from '../constants/pathInvestments';
import { DOCUMENTATION_VIEW, IDENTIFICATION_VIEW, SIGNATURE_KEY_VIEW, SIGNING_CONTRACT_VIEW } from 'constants/steps';
import { buildTgssFiocBody, checkFiocTgssFlag } from './buildTgssFiocData';
import { FUNDS_ORIGINS, FUNDS_ORIGINS_USER_PROFILE_KEYS } from 'components/FundsOriginDeclaration/constants';

const getPartner = type => {
    const partners = {
        802: PARTNER_BASIC,
        804: PARTNER_EH,
        805: PARTNER_VF,
    };

    return partners[type] || partners[802];
};

const getTheme = type => {
    const themes = {
        802: 1,
        805: 2,
        804: 3,
    };

    return themes[type] || themes[802];
};

const changeCurrentStep = data => {
    return {
        type: actionTypes.CHANGE_CURRENT_STEP,
        data,
    };
};

const finalizeStep = data => {
    return {
        type: actionTypes.FINALIZE_STEP,
        data,
    };
};

const finalizeSteps = data => {
    return {
        type: actionTypes.FINALIZE_STEPS,
        data,
    };
};

const enableStep = data => {
    return {
        type: actionTypes.ENABLE_STEP,
        data,
    };
};

const enableCurrentStep = data => {
    return {
        type: actionTypes.ENABLE_CURRENT_STEP,
        data,
    };
};

const disableFollowingStep = data => {
    return {
        type: actionTypes.DISABLE_FOLLOWING_STEP,
        data,
    };
};

const disablePreviousSteps = data => ({
    type: actionTypes.DISABLE_PREVIOUS_STEPS,
    data,
});

const enablePreviousSteps = data => ({
    type: actionTypes.ENABLE_PREVIOUS_STEPS,
    data,
});

const enableFinishedAndNextStep = () => {
    return {
        type: actionTypes.ENABLE_FINISHED_STEP,
    };
};

const selectDefaultSteps = () => {
    return {
        type: actionTypes.DEFAULT_STEPS,
    };
};

const selectAuthorizedSteps = () => {
    return {
        type: actionTypes.AUTHORIZED_STEPS,
    };
};

const selectClientSteps = () => {
    return {
        type: actionTypes.CLIENT_STEPS,
    };
};

const selectConfigCardSteps = () => {
    return {
        type: actionTypes.CONFIG_CARD_STEPS,
    };
};

const selectRoboSteps = () => {
    return {
        type: actionTypes.ROBO_STEPS,
    };
};

const selectDepositSteps = () => {
    return {
        type: actionTypes.DEPOSIT_STEPS,
    };
};

const selectCreditCardSteps = () => {
    return {
        type: actionTypes.CREDIT_CARD_STEPS,
    };
};

const selectGbiSteps = () => {
    return {
        type: actionTypes.GBI_STEPS,
    };
};

const changeMinFinalizeStep = data => {
    return {
        type: actionTypes.SET_MIN_FINALIZE_STEP,
        data,
    };
};

const savePersonalInformationService = (dispatch, saveRequestData, callback) => {
    Api.post(apiURLBuilder.getURL('personalInfo'), saveRequestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const clientVerifyService = (dispatch, requestData, callback) => {
    Api.get(apiURLBuilder.getURL('clientVerify'), requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const clientVerifyOkService = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('clientVerifyOk'), requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error.body.errors);
        }
    );
};

const clientFiocAltaService = (dispatch, getState, callback, accessToken) => {
    const isFiocTgssFlagActive = dispatch(checkFiocTgssFlag());
    const endpoint = isFiocTgssFlagActive ? 'clientFiocAltaV2' : 'clientFiocAlta';
    const method = isFiocTgssFlagActive ? 'post' : 'get';

    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: dispatch(buildTgssFiocBody({ withDocumentation: true })),
    };

    Api[method](apiURLBuilder.getURL(endpoint), requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error.body.errors);
        }
    );
};

const clientCardConfigVerifyService = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('cardConfig'), requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error.body.errors);
        }
    );
};

const clientFiocVerifyService = (dispatch, requestData, callback) => {
    Api.get(apiURLBuilder.getURL('clientFiocVerify'), requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const fillRegisterData = (dispatch, data, isJointHolder, account, holdingStatus) => {
    const products = holdingStatus.productDetails.products;
    const jointHolderOnboardingType =
        isJointHolder &&
        products.reduce((acc, product) => {
            if (product.onboardingType && product.onboardingType !== data.onboardingType) return product.onboardingType;

            return acc;
        }, undefined);

    if (isJointHolder) {
        dispatch(formActions.change('userProfile.promoCode', account.promotionalCode));
    } else {
        dispatch(formActions.change('userProfile.promoCode', data.promotionalCode));
    }
    if (data.nationality) {
        dispatch(formActions.change('userProfile.nationality', data.nationality));
    }
    dispatch(formActions.change('userProfile.name', data.name));
    dispatch(formActions.change('userProfile.lastName', data.lastname1));
    dispatch(formActions.change('userProfile.secondLastName', data.lastname2 ? data.lastname2 : ''));
    dispatch(formActions.change('userProfile.identityIban', data.iban));
    dispatch(formActions.change('userProfile.iban', data.iban));
    dispatch(formActions.change('userProfile.email', data.email));
    dispatch(formActions.change('userProfile.documentType', data.docType));
    dispatch(formActions.change('userProfile.treatment', data.treatment));
    dispatch(formActions.change('userProfile.embossingName', data.embossingName));
    dispatch(formActions.change('userProfile.docNumber', data.docNumber));
    dispatch(formActions.change('userProfile.birthDate', data.birthdate));
    dispatch(formActions.change('userProfile.showIban', false));
    dispatch(formActions.change('userProfile.acceptTerms', true));
    dispatch(formActions.change('userProfile.investmentType', holdingStatus.investmentType));
    dispatch(formActions.change('userProfile.birthCountry', data.birthCountry ? data.birthCountry : ''));
    dispatch(formActions.change('userProfile.birthPopulation', data.birthPopulation ? data.birthPopulation : ''));
    dispatch(formActions.change('userProfile.birthProvince', data.birthProvince ? data.birthProvince : ''));
    dispatch(formActions.change('userProfile.onboardingType', jointHolderOnboardingType || data.onboardingType || ''));

    dispatch({ type: actionTypes.INITIAL_STEP_COMPLETED });

    if (holdingStatus.investmentType === CREDIT_CARD) {
        const {
            creditCardData: { type, subtype, standard },
        } = data;

        dispatch(formActions.change('userProfile.productType', type));
        dispatch(formActions.change('userProfile.productSubtype', subtype));
        dispatch(formActions.change('userProfile.productStandard', standard));
    }
};

const fillPersonalInfoData = (dispatch, data, invited) => {
    let homeAddress = data.homeAddress;
    let address = null;

    dispatch(formActions.change('userProfile.showIbanAtReload', true));

    if (data.gender != null) {
        dispatch(formActions.change('userProfile.gender', data.gender));
    }
    if (data.cellphonePrefix != null) {
        dispatch(formActions.change('userProfile.cellphonePrefix', data.cellphonePrefix));
    }
    if (data.cellphone != null) {
        dispatch(
            formActions.change('userProfile.cellPhone', data.cellphone.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3'))
        );
        dispatch(
            formActions.change(
                'userProfile.cellPhoneConfirmation',
                data.cellphone.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')
            )
        );
    }
    if (data.nationality != null) {
        dispatch(formActions.change('userProfile.nationality', data.nationality));
    }
    dispatch(formActions.change('userProfile.passport', data.passport ? data.passport : ''));
    if (homeAddress != null) {
        homeAddress = data.homeAddress;
        dispatch(formActions.change('userProfile.typeOfRoad', homeAddress.typeOfRoad ? homeAddress.typeOfRoad : ''));
        dispatch(formActions.change('userProfile.nameOfRoad', homeAddress.nameOfRoad ? homeAddress.nameOfRoad : ''));
        dispatch(
            formActions.change('userProfile.addressNumber', homeAddress.addressNumber ? homeAddress.addressNumber : '')
        );
        dispatch(formActions.change('userProfile.postalCode', homeAddress.postalCode ? homeAddress.postalCode : ''));
        dispatch(formActions.change('userProfile.province', homeAddress.province ? homeAddress.province : ''));
        dispatch(
            formActions.change(
                'userProfile.addressFloorNumber',
                homeAddress.addressFloorNumber ? homeAddress.addressFloorNumber : ''
            )
        );
        dispatch(formActions.change('userProfile.department', homeAddress.department ? homeAddress.department : ''));
        dispatch(formActions.change('userProfile.town', homeAddress.town ? homeAddress.town : ''));
        dispatch(formActions.change('userProfile.country', homeAddress.country ? homeAddress.country : ''));
        dispatch(
            formActions.change(
                'userProfile.additionalInfo',
                homeAddress.additionalInfo ? homeAddress.additionalInfo : ''
            )
        );

        const language = getReferenceCodeByCountry();
        Api.get(apiURLBuilder.getURL('getCountries', { language })).then(response => {
            if (response.body) {
                address = homeAddress.nameOfRoad ? homeAddress.nameOfRoad : '';
                address = address + (homeAddress.addressNumber ? `, ${homeAddress.addressNumber}` : '');
                address = address + (homeAddress.postalCode ? `, ${homeAddress.postalCode}` : '');
                address = address + (homeAddress.town ? `, ${homeAddress.town}` : '');

                response.body.map(data => {
                    if (data.id === homeAddress.country) {
                        const country = formatText(`country-${data.languageKey}`);
                        address = `${address}, ${country.charAt(0)}${country.slice(1).toLowerCase()}`;
                    }
                });
                dispatch(formActions.change('userProfile.address', address));
                dispatch(formActions.change('userProfile.addressFilled', !!address));
            }
        });
    }

    // Joint holders
    const jointHolders = data.invites;
    if (jointHolders.length) {
        dispatch(formActions.change('userProfile.jointHolderDecision', 'true'));
        jointHolders.map((info, index) => {
            const id = index + 1;
            const docType = info.docType === 'DNI' ? 'N' : info.docType === 'NIE' ? 'C' : info.docType;
            dispatch(formActions.change(`userProfile.jointholder_${id}_name`, info.name));
            dispatch(formActions.change(`userProfile.jointholder_${id}_lastName`, info.lastname1));
            dispatch(formActions.change(`userProfile.jointholder_${id}_secondLastName`, info.lastname2));
            dispatch(formActions.change(`userProfile.jointholder_${id}_documentType`, docType));
            dispatch(formActions.change(`userProfile.jointholder_${id}_docNumber`, info.docNumber));
            dispatch(formActions.change(`userProfile.jointholder_${id}_accountType`, info.jointHolderType));
            dispatch(formActions.change(`userProfile.jointholder_${id}_email`, info.email));
            dispatch(
                formActions.change(
                    `userProfile.jointholder_${id}_openDebitCard`,
                    info.openDebitCard ? info.openDebitCard : false
                )
            );
            dispatch(formActions.push('userProfile.jointHolderIsEditing', id));
            dispatch(formActions.change('userProfile.jointHolderEditable', false));
            dispatch(formActions.push('userProfile.jointHolderCount', id));
        });
    } else {
        dispatch(formActions.change('userProfile.jointHolderDecision', 'false'));
    }

    dispatch(formActions.change('userProfile.jointHolderDecisionDisabled', invited));
    dispatch(formActions.change('userProfile.jointHolderInvited', invited));
    dispatch(formActions.change('userProfile.jointHolderAuthorizedList', invited));
    dispatch(formActions.change('userProfile.jointHolderAuthorizedList_option', invited));

    // this will fill the checkbox about legal terms when the user is already client
    dispatch(formActions.change('userProfile.clientAcceptTerms', data.legalAgree));

    if (data.invitesSent && data.invites.length) {
        dispatch(formActions.change('userProfile.jointHolderInvited', data.invitesSent));
        dispatch(formActions.change('userProfile.jointHolderDecisionDisabled', true));
        dispatch(formActions.change('userProfile.jointHolderAuthorizedList', true));
        dispatch(formActions.change('userProfile.jointHolderAuthorizedList_option', true));
    }
};

const fillPurpose = (dispatch, purpose, model) => {
    if (purpose.personal) {
        dispatch(formActions.change(model, 'personal'));
    }
    if (purpose.other) {
        dispatch(formActions.change(model, 'other'));
    }
    if (purpose.professional) {
        dispatch(formActions.change(model, 'professional'));
    }
};

const fillCapital = (dispatch, capital) => {
    dispatch(formActions.change('userProfile.capital_work', !!capital.work));
    dispatch(formActions.change('userProfile.capital_activities', !!capital.activities));
    dispatch(formActions.change('userProfile.capital_heritage', !!capital.heritage));
    dispatch(formActions.change('userProfile.capital_business', !!capital.business));
    dispatch(formActions.change('userProfile.capital_realState', !!capital.realState));
    dispatch(formActions.change('userProfile.capital_gamesOfChance', !!capital.gamesOfChance));
    dispatch(formActions.change('userProfile.capital_other', !!capital['other']));

    if (capital.other) {
        dispatch(formActions.change('userProfile.capital_other', true));
        dispatch(formActions.change('userProfile.capital_description', capital.other));
    }
    if (
        capital.work ||
        capital.activities ||
        capital.heritage ||
        capital.business ||
        capital.realState ||
        capital.gamesOfChance ||
        capital.other
    ) {
        dispatch(formActions.change('userProfile.is_patrimony', true));
    }
};

const fillFundsOrigin = (dispatch, fundsOrigins) => {
    let isAtLeastOneChecked = false;
    for (const fundOrigin in FUNDS_ORIGINS) {
        const isFundOriginChecked = fundsOrigins?.[fundOrigin] ?? false;
        dispatch(formActions.change(`userProfile.${FUNDS_ORIGINS_USER_PROFILE_KEYS[fundOrigin]}`, isFundOriginChecked));
        if (isFundOriginChecked) isAtLeastOneChecked = true;
    }

    if (isAtLeastOneChecked) {
        dispatch(formActions.change('userProfile.is_fundsOrigin', true));
    }
};

const fillIncome = (dispatch, incomes) => {
    dispatch(formActions.change('userProfile.income_work', !!incomes.work));
    dispatch(formActions.change('userProfile.income_activities', !!incomes.activities));
    dispatch(formActions.change('userProfile.income_business', !!incomes.business));
    dispatch(formActions.change('userProfile.income_realState', !!incomes.realState));
    if (incomes.other) {
        dispatch(formActions.change('userProfile.income_other', true));
        dispatch(formActions.change('userProfile.income_description', incomes.other));
    }
    if (
        incomes.work ||
        incomes.activities ||
        incomes.heritage ||
        incomes.business ||
        incomes.realState ||
        incomes.other
    ) {
        dispatch(formActions.change('userProfile.is_income', true));
    }
};

const fillSectors = (dispatch, value, model) => {
    dispatch(formActions.change(model, value));
};

const fillEmployed = (dispatch, data) => {
    const companyName = data.companyName;
    const publicCharges = data.publicCharges;
    const thirdParty = data.thirdParty;
    const purpose = data.purpose;
    const operations = data.operations;
    const capital = data.capital;
    const income = data.income;

    if (data.profession != null) {
        dispatch(formActions.change('userProfile.profession_option', data.profession.option));
        dispatch(formActions.change('userProfile.profession_category', data.profession.subcategory));
        dispatch(formActions.change(`userProfile.cno${data.profession.option}_profession_id`, data.profession.id));
    }
    if (data.annualIncomeAmount != null) {
        dispatch(formActions.change('userProfile.employed_annualIncomeAmount', data.annualIncomeAmount));
    }

    //company
    if (companyName != null) {
        dispatch(formActions.change('userProfile.employed_company', companyName ? companyName : ''));
    }
    //Has PEP
    if (publicCharges.answer != null) {
        dispatch(formActions.change('userProfile.employed_hasPEP', publicCharges.answer.toString()));
        dispatch(
            formActions.change(
                'userProfile.employed_hasPEP_details',
                publicCharges.details ? publicCharges.details : ''
            )
        );
    }
    //money
    if (thirdParty != null) {
        dispatch(formActions.change('userProfile.employed_accountMoney', thirdParty.toString()));
    }
    //purpose
    fillPurpose(dispatch, purpose, 'userProfile.employed_accountUse');

    // capitals
    fillCapital(dispatch, capital);
    fillIncome(dispatch, income);
};

const fillSelfEmployed = (dispatch, data) => {
    const companyName = data.companyName;
    const publicCharges = data.publicCharges;
    const thirdParty = data.thirdParty;
    const purpose = data.purpose;
    const operations = data.operations;
    const capital = data.capital;
    const income = data.income;
    const sectors = data.sectors;

    if (data.profession != null) {
        dispatch(formActions.change('userProfile.profession_cnae_answer', data.profession.option));
        dispatch(formActions.change('userProfile.profession_category', data.profession.subcategory));
        dispatch(formActions.change('userProfile.profession_id', data.profession.id));
    }
    if (data.annualIncomeAmount != null) {
        dispatch(formActions.change('userProfile.selfEmployed_annualIncomeAmount', data.annualIncomeAmount));
    }
    //company
    if (companyName != null) {
        dispatch(formActions.change('userProfile.selfEmployed_company', companyName ? companyName : ''));
    }
    //Has PEP
    if (publicCharges.answer != null) {
        dispatch(formActions.change('userProfile.selfEmployed_publicCharges', publicCharges.answer.toString()));
        dispatch(
            formActions.change(
                'userProfile.selfEmployed_publicCharges_details',
                publicCharges.details ? publicCharges.details : ''
            )
        );
    }
    //money
    if (thirdParty != null) {
        dispatch(formActions.change('userProfile.selfEmployed_accountMoney', thirdParty.toString()));
    }
    //purpose
    fillPurpose(dispatch, purpose, 'userProfile.selfEmployed_accountUse');
    //sectors
    // Esperando por el servicio
    fillSectors(dispatch, sectors.category, 'userProfile.selfEmployed_selfActivityA');
    fillSectors(dispatch, sectors.sector, 'userProfile.selfEmployed_selfActivityB');

    // capitals
    fillCapital(dispatch, capital);
    fillIncome(dispatch, income);
};

const fillRentier = (dispatch, data) => {
    const publicCharges = data.publicCharges;
    const thirdParty = data.thirdParty;
    const purpose = data.purpose;
    const operations = data.operations;
    const capital = data.capital;
    const income = data.income;
    if (data.annualIncomeAmount != null) {
        dispatch(formActions.change('userProfile.rentier_annualIncomeAmount', data.annualIncomeAmount));
    }
    //Has PEP
    if (publicCharges.answer != null) {
        dispatch(formActions.change('userProfile.rentier_hasPEP', publicCharges.answer.toString()));
        dispatch(
            formActions.change('userProfile.rentier_hasPEP_details', publicCharges.details ? publicCharges.details : '')
        );
    }
    //money
    if (thirdParty != null) {
        dispatch(formActions.change('userProfile.rentier_accountMoney', thirdParty.toString()));
    }
    //purpose
    fillPurpose(dispatch, purpose, 'userProfile.rentier_accountUse');

    // capitals
    fillCapital(dispatch, capital);
    fillIncome(dispatch, income);
};

const fillPensioner = (dispatch, data, professionalCategories) => {
    const companyName = data.companyName;
    const publicCharges = data.publicCharges;
    const thirdParty = data.thirdParty;
    const purpose = data.purpose;
    const operations = data.operations;
    const capital = data.capital;
    const income = data.income;

    if (data.profession != null) {
        dispatch(formActions.change('userProfile.pensioner_profession', data.profession));
    }
    if (data.position != null) {
        let pos = -1;
        professionalCategories.map(value => {
            if (data.position === value.get('label')) pos = value.get('value');
        });
        dispatch(formActions.change('userProfile.pensioner_category', pos));
    }
    if (data.annualIncomeAmount != null) {
        dispatch(formActions.change('userProfile.pensioner_annualIncomeAmount', data.annualIncomeAmount));
    }
    //company
    if (companyName != null) {
        dispatch(formActions.change('userProfile.pensioner_company', companyName ? companyName : ''));
    }
    //Has PEP
    if (publicCharges.answer != null) {
        dispatch(formActions.change('userProfile.pensioner_hasPEP', publicCharges.answer.toString()));
        dispatch(
            formActions.change(
                'userProfile.pensioner_hasPEP_details',
                publicCharges.details ? publicCharges.details : ''
            )
        );
    }
    //money
    if (thirdParty != null) {
        dispatch(formActions.change('userProfile.pensioner_accountMoney', thirdParty.toString()));
    }
    //purpose
    fillPurpose(dispatch, purpose, 'userProfile.pensioner_accountUse');

    // capitals
    fillCapital(dispatch, capital);
    fillIncome(dispatch, income);
};

const fillWithoutActivity = (dispatch, data) => {
    const publicCharges = data.publicCharges;
    const thirdParty = data.thirdParty;
    const purpose = data.purpose;
    const operations = data.operations;
    const capital = data.capital;
    const income = data.income;
    const fundsOrigins = data.fundsOrigins;

    if (data.profession != null) {
        dispatch(formActions.change('userProfile.withoutActivity_activity', data.profession.id));
    }
    if (data.annualIncomeAmount != null) {
        dispatch(formActions.change('userProfile.withoutActivity_annualIncomeAmount', data.annualIncomeAmount));
    }
    //Has PEP
    if (publicCharges.answer != null) {
        dispatch(formActions.change('userProfile.withoutActivity_hasPEP', publicCharges.answer.toString()));
        dispatch(
            formActions.change(
                'userProfile.withoutActivity_hasPEP_details',
                publicCharges.details ? publicCharges.details : ''
            )
        );
    }
    //money
    if (thirdParty != null) {
        dispatch(formActions.change('userProfile.withoutActivity_accountMoney', thirdParty.toString()));
    }
    //purpose
    fillPurpose(dispatch, purpose, 'userProfile.withoutActivity_accountUse');

    // capitals
    fillCapital(dispatch, capital);
    fillIncome(dispatch, income);

    fillFundsOrigin(dispatch, fundsOrigins);
};

const fillTaxationQuestions = (dispatch, data) => {
    const taxation = data.taxation;

    if (taxation.answer != null) {
        dispatch(formActions.change('userProfile.taxation', taxation.answer.toString()));
        if (taxation.answer) {
            taxation.taxationDetails.map((value, index) => {
                let taxation_reason = '';
                if (value.citizenship && value.residency) {
                    taxation_reason = 'AM';
                } else if (value.residency) {
                    taxation_reason = 'RE';
                } else if (value.citizenship) {
                    taxation_reason = 'CI';
                }
                dispatch(
                    formActions.change(`userProfile.taxation_country_${index}`, value.country ? value.country : '')
                );
                dispatch(formActions.change(`userProfile.taxation_reason_${index}`, taxation_reason));
                dispatch(formActions.change(`userProfile.taxation_tin_code_${index}`, value.tin ? value.tin : ''));
                dispatch(formActions.push('userProfile.taxationCounter', index));
            });
        }
    }
};

const fillCardConfig = (dispatch, data) => {
    data.map(product => {
        if (product.productType === DEBIT) {
            const cardConfig = product.cardConfig;
            if (cardConfig) {
                dispatch(formActions.change('userProfile.debitCard', cardConfig));
                dispatch(formActions.change('userProfile.homeAbroadCardSelectedId', cardConfig.cardDesignId));
                dispatch(formActions.change('userProfile.cardImageUrl', cardConfig.cardDesignUrl));
            }
        }
    });
};

const fillIncomeQuestions = (dispatch, data) => {
    data.monthlyRenting !== null && dispatch(formActions.change('userProfile.monthlyRenting', data.monthlyRenting));
    data.monthlyMortgage !== null && dispatch(formActions.change('userProfile.monthlyMortgage', data.monthlyMortgage));
    data.monthlyLoan !== null && dispatch(formActions.change('userProfile.monthlyLoan', data.monthlyLoan));
};

const fillFioc = (dispatch, data, professionalCategories) => {
    const accountType = data.accountType;

    dispatch(formActions.change('userProfile.accountType', accountType));

    switch (accountType) {
        case '01':
            fillSelfEmployed(dispatch, data);
            break;
        case '02':
            fillEmployed(dispatch, data, professionalCategories);
            break;
        case '03':
            fillRentier(dispatch, data);
            break;
        case '04':
            fillPensioner(dispatch, data, professionalCategories);
            break;
        case '05':
            fillWithoutActivity(dispatch, data);
            break;
        default:
            break;
    }

    fillTaxationQuestions(dispatch, data);
    fillIncomeQuestions(dispatch, data);
};

const fillIdentify = (dispatch, data) => {
    if (!data) {
        return;
    }

    dispatch(formActions.change('userProfile.identityVideoBlocked', data.blocked));
    const nullToUndefinedIdentityStatus = data.status === null ? undefined : data.status;
    dispatch(formActions.change('userProfile.identityStatus', nullToUndefinedIdentityStatus));

    if (data.method === 'videocall' && data.blocked) {
        dispatch(formActions.change('userProfile.identityMethod', ''));
    } else {
        dispatch(formActions.change('userProfile.identityMethod', data.method));
    }

    if (data.method === 'iban') {
        const iban = data.extra.split(' ').join('');
        dispatch(formActions.change('userProfile.identityIban', iban));
        // dispatch({ type: actionTypes.OKIBAN_SET_IBAN, iban: iban });
    }

    if (data.method === 'correos' && (data.status === 'programmed' || data.status === '2' || data.status === '3')) {
        dispatch(formActions.change('userProfile.postOfficeBranch', data.extra.split('|')[0].trim()));
        dispatch(formActions.change('userProfile.postOfficePostalCode', data.extra.split('|')[1].trim()));
        dispatch(formActions.change('userProfile.postOfficePopulation', data.extra.split('|')[2].trim()));
    }

    if (data.method === 'courier') {
        if (data.status === 'programmed') {
            const date = data.extra.split('|')[0];
            const day = date.split('/')[0];
            const month = date.split('/')[1];
            const year = date.split('/')[2];
            const dateToVisit = year + month + day;
            dispatch(formActions.change('userProfile.dateToVisit', dateToVisit));
        }

        if (data.status === 'incomplete') {
            // NOTA: Si no devuelvo el identityMethod a null en este momento la aplicacion se comienza a
            //       comportar de manera impredecible. Esto es porque originalmente la direccion del cou
            //       rier no se guardaba por separado y solo se enviaba al final cuando se hace submit.
            //       Como ahora es un requerimiento el recordar la direccion del courier por separado y
            //       no cuando se hace submit, cuando se guarda la direccion en el BE el metodo es cambiado
            //       a 'courier' pero la logica en el frontend no espera que el metodo sea courier a menos
            //       que ya haya sido submiteado y causaba comportamientos impredecibles en el FE. Retornando
            //       el valor a null soluciona estos problemas.
            dispatch(formActions.change('userProfile.identityMethod', null));
        }

        if (!tools.isEmptyOrWhitespace(data.extra)) {
            const extras = data.extra.split('|');
            let savedAddress, additionalInfo;

            if (data.status === 'programmed') {
                [, savedAddress = '', additionalInfo = ''] = extras;

                dispatch(formActions.change('userProfile.courierAddress', savedAddress));
                dispatch(formActions.change('userProfile.courierAddressInfo', additionalInfo));
            } else {
                [savedAddress = '', additionalInfo = ''] = extras;
                const [
                    typeOfRoad = '',
                    nameOfRoad = '',
                    addressNumber = '',
                    postalCode = '',
                    town = '',
                    province = '',
                    country = '',
                ] = savedAddress.split(',');

                const formattedAddress = `${nameOfRoad}, ${addressNumber}, ${postalCode}, ${town}`;
                dispatch(formActions.change('userProfile.address_has_cache', true));

                dispatch(formActions.change('userProfile.address_2_cache', formattedAddress));

                dispatch(formActions.change('userProfile.courierAddress', formattedAddress));
                dispatch(formActions.change('userProfile.courierAddressInfo', additionalInfo));

                dispatch(formActions.change('userProfile.additionalInfo_2_cache', additionalInfo));
                dispatch(formActions.change('userProfile.typeOfRoad_2_cache', typeOfRoad));
                dispatch(formActions.change('userProfile.nameOfRoad_2_cache', nameOfRoad));
                dispatch(formActions.change('userProfile.addressNumber_2_cache', addressNumber));
                dispatch(formActions.change('userProfile.postalCode_2_cache', postalCode));
                dispatch(formActions.change('userProfile.town_2_cache', town));
                dispatch(formActions.change('userProfile.province_2_cache', province));
                dispatch(formActions.change('userProfile.country_2_cache', country));
                dispatch(formActions.change('userProfile.address_2Filled', !!formattedAddress));
            }
        }
    }

    if (data.method === 'videocall') {
        const year = data.datetime.split('-')[0];
        const month = data.datetime.split('-')[1];
        let day = data.datetime.split('-')[2];
        let hour = day.split('T')[1];
        const min = hour.split(':')[1];
        const months = [
            formatText('fullMonths-january'),
            formatText('fullMonths-february'),
            formatText('fullMonths-march'),
            formatText('fullMonths-april'),
            formatText('fullMonths-may'),
            formatText('fullMonths-june'),
            formatText('fullMonths-july'),
            formatText('fullMonths-august'),
            formatText('fullMonths-september'),
            formatText('fullMonths-october'),
            formatText('fullMonths-november'),
            formatText('fullMonths-december'),
        ];

        hour = hour.split(':')[0];
        day = day.split('T')[0];

        dispatch(formActions.change('userProfile.videoCallDay', day));
        dispatch(formActions.change('userProfile.videoCallMount', month));
        dispatch(formActions.change('userProfile.videoCallMountName', months[month - 1]));
        dispatch(formActions.change('userProfile.videoCallYear', year));
        dispatch(formActions.change('userProfile.videoCallHour', hour));
        dispatch(formActions.change('userProfile.videoCallminutes', min));

        mapVideocallStatus(data.status, param => {
            dispatch(formActions.change('userProfile.identityStatus', param));
        });
    }
};

const manageWelcomeCard = (dispatch, login = false) => {
    if (login) dispatch({ type: 'SHOW_WELCOME_CARD' });
};

const fillScoring = (dispatch, data) => {
    const scoring = {};

    if (data.digilantStatus) {
        scoring.scoringStatus = data.digilantStatus;
        scoring.cardLimit = data.digilantLimit;
        dispatch(scoringActions.setScoringML2(scoring));
    }

    if (data.jaffarStatus) {
        scoring.scoringStatus = data.jaffarStatus;
        scoring.cardLimit = data.jaffarLimit;
        dispatch(scoringActions.setScoringJaffar(scoring));
    }
};

const fillCreditCard = (dispatch, creditCard) => {
    const paymentInfo = creditCard ? creditCard.paymentInfo : null;
    if (creditCard) {
        dispatch(formActions.change('userProfile.creditCard', creditCard));
        dispatch(formActions.change('userProfile.openCreditCardSelectedId', creditCard.cardDesignId));
        dispatch(formActions.change('userProfile.cardImageUrl', creditCard.cardDesignUrl));
    }

    if (paymentInfo) {
        dispatch(formActions.change('userProfile.paymentMethodType', paymentInfo.paymentType));

        if (paymentInfo.paymentType === FIXED_PAYMENT_METHOD_VALUE) {
            dispatch(formActions.change('userProfile.fixedPaymentMethodValue', paymentInfo.installmentAmount));
        }
        if (paymentInfo.paymentType === VARIABLE_PAYMENT_METHOD_VALUE) {
            dispatch(formActions.change('userProfile.variablePaymentMethodValue', paymentInfo.percentage));
        }
    }
};

const fillSuitabilityTest = dispatch => {
    if (ALLOW_COOKIE && Storage.cookies.get('openBankToken')) {
        dispatch(checkStatusActions.checkStatus()).then(() => {
            dispatch(suitabilityActions.getTestQuestions());
            dispatch(suitabilityActions.getTestResult());
        });
    }
};

const fillObjectivesSelection = (dispatch, accessToken) => {
    if (accessToken) {
        dispatch(preLoaderActions.showPreLoader());
        dispatch(raSetGoalActions.getGoalOnboarding(accessToken))
            .then(() => dispatch(preLoaderActions.hidePreLoader()))
            .catch(() => dispatch(preLoaderActions.hidePreLoader()));
    }
};

const fillStepsNew = (dispatch, data, professionalCategories, withToken = false, login = false, storage) => {
    const register = data.register;
    const personalInfo = data.additional;
    const fioc = data.fioc;
    const identification = data.identification;
    const identifiedSuccessfully = data.identifiedSuccessfully;
    const contract = data.contract;
    const currentStep = 0;
    const holdingStatus = data.holdingStatuses[0];
    const isJointHolder = holdingStatus.holdingType === 'cotitular' || holdingStatus.holdingType === 'autorizado';
    const isAuthorized = holdingStatus.holdingType === 'autorizado';
    const account = holdingStatus.account;
    const isAlreadyClient = holdingStatus.alreadyClient;
    const status = isAlreadyClient ? holdingStatus.status : data.status;
    const products = holdingStatus.productDetails.products;
    const wealthProduct = data.wealthProduct;
    const creditCard = data.creditCard;
    const checkOpenCredit = data.checkOpenCredit;
    const scoringInfo = data.scoringInfo;
    const isRobo = holdingStatus.investmentType === ROBO;
    const isGbi = holdingStatus.investmentType === GBI;
    const isRoboRejected = holdingStatus.investmentType === ROBO_REJECTED;
    const isGbiRejected = holdingStatus.investmentType === GBI_REJECTED;
    const isCreditCard = holdingStatus.investmentType === CREDIT_CARD;
    const isAresLoan = holdingStatus.investmentType === LOAN;
    const viewName = getViewNameByStatus(status);

    const identificationDataReset = (login, storage) => {
        login && storage.remove('identification');
    };

    let promoConfigCard = false;
    let step;
    let wealth = {
        wealthType: null,
        wealthCode: null,
        wealthName: null,
    };

    if (!isJointHolder) {
        products.forEach(product => {
            if (product.productType === DEBIT) {
                promoConfigCard = true;
            }
        });
    }

    if (wealthProduct && !isJointHolder) {
        wealth = {
            wealthType: data.wealthProduct.typeProduct,
            wealthCode: data.wealthProduct.codeProduct,
            wealthName: data.wealthProduct.nameProduct,
        };

        dispatch(wealthProductActions.setWealthProduct(wealth));
    }

    if (checkOpenCredit) {
        fillScoring(dispatch, scoringInfo);
        fillCreditCard(dispatch, creditCard);
    }

    if (isAresLoan) {
        const eventParam = StringHelper.getParameterByName('event');
        if (withToken && eventParam) {
            if (eventParam === 'Exception' || eventParam === 'exception' || eventParam === 'ttl_expired') {
                dispatch(formActions.change('userProfile.contract', 'exception'));
            } else if (eventParam === 'id_check_failed') {
                dispatch(formActions.change('userProfile.contract', 'idCheckFailed'));
            } else {
                dispatch(formActions.change('userProfile.eventParam', eventParam));
            }
        }

        fillFioc(dispatch, fioc, professionalCategories);
        dispatch(optionsActions.setLoadAres(false));
        history.push(`${BASE_PATH}/${LOAN_PATH}`);

        return;
    }

    if (!viewName) {
        dispatch(formActions.change('userProfile.name', null));
        history.push(`${BASE_PATH}/errors`);

        return;
    }

    const doChangeStep = viewNameToGo => {
        dispatch(changeCurrentStep({ viewName: viewNameToGo || viewName }));
    };

    const doChangeMinFinalizeStep = () => {
        dispatch(changeMinFinalizeStep({ viewName }));
    };

    const doFinalizeSteps = viewNameToGo => {
        dispatch(finalizeSteps({ viewName: viewNameToGo || viewName }));
    };

    const doFinalizeAStep = viewNameToGo => {
        dispatch(finalizeStep({ viewName: viewNameToGo || viewName, finished: true }));
    };

    switch (status) {
        case TRANSFER_OTP:
        case PENDING_OTP:
            fillSuitabilityTest(dispatch);
            doChangeMinFinalizeStep();
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            fillFioc(dispatch, fioc, professionalCategories);
            if (!isJointHolder || (!isAuthorized && !isAlreadyClient)) {
                fillIdentify(dispatch, identification);
                dispatch(formActions.change('userProfile.identified', true));
            }
            //finalize contact - fioc - identify - contract
            doFinalizeSteps();
            dispatch(enableFinishedAndNextStep());
            //finalize contract sign
            dispatch(formActions.change('userProfile.contract', COMPLETED));
            //finalize document
            dispatch(formActions.change('userProfile.documentation', 'ready'));
            dispatch(formActions.change('userProfile.status', status));
            manageWelcomeCard(dispatch, login);
            doChangeStep();

            history.push(`${BASE_PATH}/steps`);
            break;
        case LIMIT_CREDIT:
        case LIMIT_CREDIT_INE:
        case EXTERNAL_IBAN:
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            fillFioc(dispatch, fioc, professionalCategories);
            fillIdentify(dispatch, identification);
            manageWelcomeCard(dispatch, login);
            dispatch(changeMinFinalizeStep({ index: 4 }));
            dispatch(finalizeSteps({ index: 3 }));
            dispatch(enableFinishedAndNextStep());
            dispatch(changeCurrentStep({ index: 3 }));
            history.push(`${BASE_PATH}/steps`);
            break;
        case REGISTER_STATUS:
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            manageWelcomeCard(dispatch, login);
            history.push(`${BASE_PATH}/steps`);
            break;

        case DEPOSIT_CONFIG_STATUS:
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            doFinalizeSteps();
            dispatch(enableFinishedAndNextStep());
            doChangeStep();
            manageWelcomeCard(dispatch, login);

            history.push(`${BASE_PATH}/steps`);
            break;

        case SIGNATURE_KEY:
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);

            doChangeMinFinalizeStep();
            doFinalizeSteps();
            dispatch(enableFinishedAndNextStep());
            doChangeStep();
            manageWelcomeCard(dispatch, login);

            history.push(`${BASE_PATH}/steps`);
            break;

        case ADDITIONAL_STATUS:
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, false);
            manageWelcomeCard(dispatch, login);
            history.push(`${BASE_PATH}/steps`);
            break;
        case OBJECTIVES_SELECTION_STATUS:
            step = parseInt(currentStep) + 1;
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, false);
            dispatch(changeMinFinalizeStep({ index: 5 }));
            dispatch(finalizeSteps({ index: step }));
            dispatch(enableFinishedAndNextStep());
            dispatch(changeCurrentStep({ index: step }));
            manageWelcomeCard(dispatch, login);
            history.push(`${BASE_PATH}/steps`);
            break;
        case SUITABILITY_TEST_STATUS:
            step = parseInt(currentStep) + 1;
            if (isGbi) {
                step = parseInt(currentStep) + 2;
            }
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, false);
            fillObjectivesSelection(dispatch, Storage.cookies.get('accessToken'));
            dispatch(changeMinFinalizeStep({ index: 4 }));
            dispatch(finalizeSteps({ index: step }));
            dispatch(enableFinishedAndNextStep());
            dispatch(changeCurrentStep({ index: step }));
            manageWelcomeCard(dispatch, login);
            history.push(`${BASE_PATH}/steps`);
            break;
        case SIMULATION_STATUS:
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, false);
            fillObjectivesSelection(dispatch, Storage.cookies.get('accessToken'));
            doChangeMinFinalizeStep();
            doFinalizeSteps();
            dispatch(enableFinishedAndNextStep());
            doChangeStep();
            manageWelcomeCard(dispatch, login);
            history.push(`${BASE_PATH}/steps`);
            break;
        case CARD_CONFIG_STATUS:
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, false);
            fillCardConfig(dispatch, products);
            doChangeMinFinalizeStep();
            dispatch(enableFinishedAndNextStep());
            doChangeStep();
            manageWelcomeCard(dispatch, login);
            history.push(`${BASE_PATH}/steps`);
            break;
        case READY_STATUS:
        case WAITING:
        case JAFFAR_STATUS:
        case FIOC:
        case DEBIT_CARD:
        case DEBIT_CARD_PIN:
            doChangeMinFinalizeStep();

            if (promoConfigCard) {
                fillCardConfig(dispatch, products);
            } else if (isRobo) {
                fillSuitabilityTest(dispatch);
            } else if (isRoboRejected) {
                dispatch(formActions.change('userProfile.withoutRobo', true));
            } else if (isGbi) {
                fillSuitabilityTest(dispatch);
            } else if (isGbiRejected) {
                fillSuitabilityTest(dispatch);
                dispatch(formActions.change('userProfile.withoutGbi', true));
            }

            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            fillFioc(dispatch, fioc, professionalCategories);
            doFinalizeSteps();
            dispatch(enableFinishedAndNextStep());
            doChangeStep();
            if (status !== WAITING) {
                manageWelcomeCard(dispatch, login);
            }

            if (status === JAFFAR_STATUS) {
                if (scoringInfo.digilantStatus === 'disapproved' && scoringInfo.jaffarStatus === 'disapproved') {
                    dispatch(scoringActions.getLimitJaffar(Storage.cookies.get('accessToken')));
                }
                dispatch(formActions.change('userProfile.showOpenCredit', true));
            }

            if (status === DEBIT_CARD || status === DEBIT_CARD_PIN) {
                dispatch(formActions.change('userProfile.status', DEBIT_CARD));
            }

            history.push(`${BASE_PATH}/steps`);
            break;
        case BATCH_STATUS:
            if (promoConfigCard) {
                fillCardConfig(dispatch, products);
            }

            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            fillFioc(dispatch, fioc, professionalCategories);
            //finalize contact
            doFinalizeSteps();
            dispatch(enableFinishedAndNextStep());
            doChangeStep();
            dispatch({ type: actionTypes.BATCH_ERROR, data: true });
            history.push(`${BASE_PATH}/steps`);
            break;
        case CREATED_STATUS: {
            identificationDataReset(login, storage);
            let viewNameToGo = IDENTIFICATION_VIEW;
            if (promoConfigCard) {
                fillCardConfig(dispatch, products);
            } else if (isRobo) {
                viewNameToGo = SIGNATURE_KEY_VIEW;
            } else if (isGbi) {
                viewNameToGo = SIGNING_CONTRACT_VIEW;
            }

            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            fillFioc(dispatch, fioc, professionalCategories);
            doFinalizeSteps(viewNameToGo);
            dispatch(enableFinishedAndNextStep());
            manageWelcomeCard(dispatch, login);
            doChangeStep(viewNameToGo);
            history.push(`${BASE_PATH}/steps`);
            break;
        }
        case IDENTIFICATION_ABORTED:
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            fillFioc(dispatch, fioc, professionalCategories);
            fillIdentify(dispatch, identification);
            history.push(`${BASE_PATH}/steps`);
            break;
        case IDENTIFICATION_ROBO:
            identificationDataReset(login, storage);
        case IDENTIFIED_ROBO:
            fillSuitabilityTest(dispatch);
            doChangeMinFinalizeStep();

            if (isRoboRejected) {
                dispatch(formActions.change('userProfile.withoutRobo', true));
                doChangeMinFinalizeStep(DOCUMENTATION_VIEW);
            }

            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            fillFioc(dispatch, fioc, professionalCategories);
            fillIdentify(dispatch, identification);
            manageWelcomeCard(dispatch, login);

            if (status === IDENTIFIED_ROBO || identification.status === COMPLETED) {
                doChangeMinFinalizeStep(DOCUMENTATION_VIEW);
                dispatch(enableFinishedAndNextStep());
                doChangeStep(DOCUMENTATION_VIEW);
            } else {
                doChangeStep();
                identificationDataReset(login, storage);
            }

            dispatch(formActions.change('userProfile.status', PRE_DOCUMENTATION));
            history.push(`${BASE_PATH}/steps`);
            break;
        case IDENTIFICATION:
            identificationDataReset(login, storage);
        case IDENTIFIED:
            if (promoConfigCard) {
                fillCardConfig(dispatch, products);
                dispatch(formActions.change('userProfile.identified', true));
            } else if (isRobo) {
                fillSuitabilityTest(dispatch);
                doChangeMinFinalizeStep();
            } else if (isRoboRejected) {
                dispatch(formActions.change('userProfile.withoutRobo', true));
                doChangeMinFinalizeStep();
            } else if (isGbi) {
                fillSuitabilityTest(dispatch);
                doChangeMinFinalizeStep();
            } else if (isGbiRejected) {
                fillSuitabilityTest(dispatch);
                dispatch(formActions.change('userProfile.withoutGbi', true));
                doChangeMinFinalizeStep();
            } else if (isCreditCard) {
                fillSuitabilityTest(dispatch);
                doChangeMinFinalizeStep();
            }

            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            fillFioc(dispatch, fioc, professionalCategories);
            fillIdentify(dispatch, identification);
            //finalize contact - fioc
            doFinalizeSteps();
            dispatch(enableFinishedAndNextStep());
            //finalize Identity
            !identifiedSuccessfully && manageWelcomeCard(dispatch, login);
            doChangeStep();
            history.push(`${BASE_PATH}/steps`);
            break;
        case CONTRACT:
        case SIGNED:
            if (promoConfigCard) {
                fillCardConfig(dispatch, products);
            } else if (isRobo) {
                fillSuitabilityTest(dispatch);
                doChangeMinFinalizeStep();
            } else if (isRoboRejected) {
                dispatch(formActions.change('userProfile.withoutRobo', true));
                doChangeMinFinalizeStep();
            } else if (isGbi) {
                fillSuitabilityTest(dispatch);
                doChangeMinFinalizeStep();
            } else if (isGbiRejected) {
                fillSuitabilityTest(dispatch);
                dispatch(formActions.change('userProfile.withoutGbi', true));
                doChangeMinFinalizeStep();
            } else if (isCreditCard) {
                fillSuitabilityTest(dispatch);
                doChangeMinFinalizeStep();
            }
            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            fillFioc(dispatch, fioc, professionalCategories);
            if (!isRobo && (!isJointHolder || (!isAuthorized && !isAlreadyClient))) {
                fillIdentify(dispatch, identification);
                dispatch(formActions.change('userProfile.identified', true));
            }
            //finalize contact - fioc - identify
            doFinalizeSteps();
            dispatch(enableFinishedAndNextStep());
            //finalize contract sign
            if (withToken) {
                const eventParam = StringHelper.getParameterByName('event');
                dispatch(formActions.change('userProfile.contract', contract.status));
                dispatch(formActions.change('userProfile.eventParam', eventParam));
                if (eventParam === 'signing_complete') {
                    dispatch(formActions.change('userProfile.contract', contract.status));
                }
                if (eventParam === 'Exception' || eventParam === 'exception' || eventParam === 'ttl_expired') {
                    dispatch(formActions.change('userProfile.contract', 'exception'));
                }
                if (eventParam === 'id_check_failed') {
                    dispatch(formActions.change('userProfile.contract', 'idCheckFailed'));
                }
            } else {
                dispatch(formActions.change('userProfile.contract', contract.status));
            }

            manageWelcomeCard(dispatch, login);
            doChangeStep();
            history.push(`${BASE_PATH}/steps`);
            break;
        case PRE_DOCUMENTATION:
        case UPDATING_DOCUMENTATION_STATUS:
        case DOCUMENTATION:
        case STAND_BY:
        case SUCCESS:
        case ACTIVATED:
            if (promoConfigCard) {
                fillCardConfig(dispatch, products);
            } else if (isRobo) {
                fillSuitabilityTest(dispatch);
                doChangeMinFinalizeStep();
            } else if (isRoboRejected) {
                dispatch(formActions.change('userProfile.withoutRobo', true));
                doChangeMinFinalizeStep();
            } else if (isGbi) {
                fillSuitabilityTest(dispatch);
                doChangeMinFinalizeStep();
            } else if (isGbiRejected) {
                fillSuitabilityTest(dispatch);
                dispatch(formActions.change('userProfile.withoutGbi', true));
                doChangeMinFinalizeStep();
            } else if (isCreditCard) {
                fillSuitabilityTest(dispatch);
                doChangeMinFinalizeStep();
            }

            fillRegisterData(dispatch, register, isJointHolder, account, holdingStatus);
            fillPersonalInfoData(dispatch, personalInfo, creditCard, true);
            fillFioc(dispatch, fioc, professionalCategories);
            if (!isJointHolder || (!isAuthorized && !isAlreadyClient && !isRobo && !isGbi)) {
                fillIdentify(dispatch, identification);
                dispatch(formActions.change('userProfile.identified', true));
            }
            doFinalizeSteps();
            dispatch(enableFinishedAndNextStep());
            dispatch(formActions.change('userProfile.contract', COMPLETED));
            dispatch(formActions.change('userProfile.documentation', 'ready'));

            if (status === STAND_BY || status === SUCCESS) {
                doFinalizeAStep();
            }

            manageWelcomeCard(dispatch, login);
            doChangeStep();
            history.push(`${BASE_PATH}/steps`);
            break;
        case CANCELLED_STATUS:
        case PRE_CANCELLED_STATUS:
            dispatch(formActions.change('userProfile.name', null));
            history.push(`${BASE_PATH}/steps`);
            break;
        default:
            break;
    }
};

const fillSteps = (dispatch, data, professionalCategories, withToken = false, login = false, storage) => {
    const extra = data.extra;
    const personalInfo = data.additional;
    const invites = personalInfo ? personalInfo.invites : [];
    const holdingStatuses = data.holdingStatuses[0];
    const onboardingType = data.register?.onboardingType;
    const isJointHolder = holdingStatuses.holdingType === 'cotitular' || holdingStatuses.holdingType === 'autorizado';
    const isJointHolderAccount = isJointHolder || (holdingStatuses.holdingType === 'titular' && invites.length > 0);
    const isAlreadyClient = holdingStatuses.alreadyClient;
    const status = isAlreadyClient ? holdingStatuses.status : data.status;
    const productDetails = holdingStatuses.productDetails;
    const products = productDetails.products;
    const isRobo = holdingStatuses.investmentType === ROBO || holdingStatuses.investmentType === 'robo-rejected';
    const isDeposit = holdingStatuses.investmentType === TRADITIONAL && onboardingType === ONB_BANK_DEPOSIT_OPEN;
    const isGbi = holdingStatuses.investmentType === GBI || holdingStatuses.investmentType === 'gbi-rejected';
    const isCreditCard = holdingStatuses.investmentType === CREDIT_CARD;
    const productsInfo = {
        products,
    };
    const creditCardOffer = data.checkOpenCredit;
    let isConfigCard = false;
    if (!isJointHolder) {
        products.forEach(product => {
            if (product.productType === DEBIT) {
                isConfigCard = true;
            }
        });
    }
    if (isCreditCard) {
        dispatch({
            type: actionTypes.LOAD_PARTNER,
            data: {
                id: getPartner(data.register.creditCardData.subtype),
                theme: getTheme(data.register.creditCardData.subtype),
            },
        });
    }

    dispatch(formActions.change('userProfile.channel', data.channel));
    dispatch(formActions.change('userProfile.recordId', extra.footprint));
    dispatch(formActions.change('userProfile.product', extra.product));
    dispatch(
        formActions.change(
            'userProfile.userId',
            extra.codigoPersona !== null ? extra.tipoPersona + extra.codigoPersona : ''
        )
    );
    dispatch(formActions.change('userProfile.datetime', extra.datetime));
    dispatch(formActions.change('userProfile.jointHolderType', holdingStatuses.holdingType));
    dispatch(formActions.change('userProfile.isJointHolderAccount', isJointHolderAccount));
    dispatch(formActions.change('userProfile.isJointHolderNoClient', !isAlreadyClient));
    dispatch(formActions.change('userProfile.isAlreadyClient', isAlreadyClient));
    dispatch(formActions.change('userProfile.openDebitCard', holdingStatuses.openDebitCard));
    dispatch(formActions.change('userProfile.status', status));
    dispatch(formActions.change('userProfile.withConfigCard', isConfigCard));
    dispatch(formActions.change('userProfile.creditCardOffer_accepted', creditCardOffer));
    dispatch(formActions.change('userProfile.isJointHolder', isJointHolder));
    dispatch(formActions.change('userProfile.investmentType', holdingStatuses.investmentType));
    dispatch(productsActions.clearProductsInfo());
    dispatch(productsActions.setProductsInfo(productsInfo));
    if (productDetails.promotionalCode) {
        dispatch(promotionalCodeAction.setPromoCode(productDetails));
    }

    if (holdingStatuses.mainHolderName) {
        dispatch(formActions.change('userProfile.mainHolderName', holdingStatuses.mainHolderName));
    }

    if (isAlreadyClient) {
        changeMinFinalizeStep({ index: 0 });
        dispatch(selectClientSteps());
    } else if (holdingStatuses.holdingType === 'autorizado') {
        dispatch(selectAuthorizedSteps());
    } else if (isDeposit && !isJointHolder) {
        dispatch(selectDepositSteps());
    } else if (isConfigCard && !isJointHolder) {
        dispatch(selectConfigCardSteps());
    } else if (isRobo) {
        dispatch(selectRoboSteps());
    } else if (isGbi) {
        dispatch(selectGbiSteps());
    } else if (isCreditCard) {
        dispatch(selectCreditCardSteps());
    }

    fillStepsNew(dispatch, data, professionalCategories, withToken, login, storage);
};

const getOnboardingService = (dispatch, accessToken, professionalCategories, callback) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    Api.get(apiURLBuilder.getURL('getOnboarding'), requestData).then(
        response => {
            if (response.body) {
                dispatch(formActions.change('userProfile.accessToken', accessToken));
                const data = response.body;
                const expires = new Date(new Date().getTime() + 45 * 60 * 1000);

                if (ALLOW_COOKIE && Storage.cookies.get('refreshToken')) {
                    const refreshToken = Storage.cookies.get('refreshToken');
                    dispatch(formActions.change('userProfile.refreshToken', refreshToken));
                }
                if (data.accessToken != null) {
                    dispatch(formActions.change('userProfile.accessToken', data.accessToken));
                    if (ALLOW_COOKIE) {
                        Storage.cookies.set('accessToken', data.accessToken, {
                            expires,
                        });
                    }
                }
                if (data.refreshToken != null) {
                    dispatch(formActions.change('userProfile.refreshToken', data.refreshToken));
                    if (ALLOW_COOKIE) {
                        Storage.cookies.set('refreshToken', data.refreshToken, {
                            expires,
                        });
                    }
                }
                dispatch(formActions.change('userProfile.identifiedSuccessfully', data.identifiedSuccessfully));
                dispatch(formActions.change('userProfile.documentationStatusCounter', data.documentationStatusCounter));
                fillSteps(dispatch, data, professionalCategories);
            }
            callback();
            dispatch(formActions.change('userProfile.getOnboardingService', true));
        },
        () => {
            Storage.cookies.remove('accessToken');
            Storage.cookies.remove('refreshToken');
            callback();
        }
    );
};

const getOnboardingServiceByToken = (dispatch, contractToken, professionalCategories, callback) => {
    const url = apiURLBuilder.getURL('getOnboardingByToken', {
        contractToken,
    });
    Api.get(url).then(
        response => {
            if (response.body) {
                const data = response.body;
                const expires = new Date(new Date().getTime() + 45 * 60 * 1000);

                if (data.accessToken != null) {
                    dispatch(formActions.change('userProfile.accessToken', data.accessToken));
                    if (ALLOW_COOKIE) {
                        Storage.cookies.set('accessToken', data.accessToken, {
                            expires,
                        });
                    }
                }

                if (data.refreshToken != null) {
                    dispatch(formActions.change('userProfile.refreshToken', data.refreshToken));
                    if (ALLOW_COOKIE) {
                        Storage.cookies.set('refreshToken', data.refreshToken, {
                            expires,
                        });
                    }
                }

                fillSteps(dispatch, data, professionalCategories, true);
            }
            callback(true);
        },
        () => {
            callback(false);
        }
    );
};

const savePersonalInformation = (data, accessToken, showLoader, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: data,
        };

        if (showLoader) dispatch(preLoaderActions.showPreLoader());
        savePersonalInformationService(dispatch, saveRequestData, callback);
    };
};

const clientVerify = (accessToken, callback) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };

        clientVerifyService(dispatch, requestData, callback);
    };
};

const clientVerifyOk = (accessToken, callback) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };

        clientVerifyOkService(dispatch, requestData, callback);
    };
};

const clientCardConfigVerify = (accessToken, callback) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };

        clientCardConfigVerifyService(dispatch, requestData, callback);
    };
};

const clientFiocVerify = (accessToken, callback) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };

        clientFiocVerifyService(dispatch, requestData, callback);
    };
};

const clientFiocAlta = (accessToken, callback) => {
    return (dispatch, getState) => {
        clientFiocAltaService(dispatch, getState, callback, accessToken);
    };
};

const getOnboardingInformation = (accessToken, professionalCategories, callback) => {
    return dispatch => {
        dispatch(preLoaderActions.showPreLoader());
        getOnboardingService(dispatch, accessToken, professionalCategories, callback);
    };
};

const getOnboardingInformationByToken = (contractToken, professionalCategories, callback) => {
    return dispatch => {
        dispatch(preLoaderActions.showPreLoader());
        getOnboardingServiceByToken(dispatch, contractToken, professionalCategories, callback);
    };
};

const getOnboardingInformationServiceByToken = (
    dispatch,
    accessToken,
    professionalCategories,
    login = false,
    storage
) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    Api.get(apiURLBuilder.getURL('getOnboarding'), requestData)
        .then(response => {
            if (response.body) {
                dispatch(
                    formActions.change(
                        'userProfile.documentationStatusCounter',
                        response.body.documentationStatusCounter
                    )
                );
                dispatch(
                    formActions.change('userProfile.identifiedSuccessfully', response.body.identifiedSuccessfully)
                );
                fillSteps(dispatch, response.body, professionalCategories, true, login, storage);
                dispatch({ type: 'HIDE_SPINNER' });
                dispatch(formActions.change('userProfile.getOnboardingInformationServiceByToken', true));
            }
        })
        .catch(() => {
            dispatch(formActions.change('userProfile.initialOnboardingRequestFailure', true));

            setTimeout(() => {
                history.push(`${BASE_PATH}/errors`);
            }, 300);
        });
};

const getInformationServiceByToken = (dispatch, token, professionalCategories, login = false, storage) => {
    const url = apiURLBuilder.getURL('getInformationByToken', { token });
    Api.get(url).then(
        response => {
            if (response.body) {
                const data = response.body;
                const expires = new Date(new Date().getTime() + 45 * 60 * 1000);

                dispatch(formActions.change('userProfile.documentationStatusCounter', data.documentationStatusCounter));

                if (data.accessToken) {
                    dispatch(formActions.change('userProfile.accessToken', data.accessToken));
                    if (ALLOW_COOKIE) {
                        Storage.cookies.set('accessToken', data.accessToken, {
                            expires,
                        });
                    }

                    if (data.refreshToken) {
                        dispatch(formActions.change('userProfile.refreshToken', data.refreshToken));
                        if (ALLOW_COOKIE) {
                            Storage.cookies.set('refreshToken', data.refreshToken, { expires });
                        }
                    }

                    getOnboardingInformationServiceByToken(
                        dispatch,
                        data.accessToken,
                        professionalCategories,
                        login,
                        storage
                    );
                }
            }
        },
        () => {
            history.push(`${BASE_PATH}/errors`);
        }
    );
};

const getInformationByToken = (token, professionalCategories, login = false, storage) => {
    return dispatch => {
        getInformationServiceByToken(dispatch, token, professionalCategories, login, storage);
    };
};

const resetStore = () => {
    return dispatch => {
        dispatch({ type: 'RESET_STORE' });
    };
};

const showWelcomeCard = () => {
    return dispatch => {
        dispatch({ type: 'SHOW_WELCOME_CARD' });
    };
};

const hideWelcomeCard = () => {
    return dispatch => {
        dispatch({ type: 'HIDE_WELCOME_CARD' });
    };
};

const preDocumentationOkService = (accessToken, callback) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: {},
    };
    Api.post(apiURLBuilder.getURL('preDocumentationOk'), requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error.body.errors);
        }
    );
};

const preDocumentationOk = (accessToken, callback) => {
    return () => {
        preDocumentationOkService(accessToken, callback);
    };
};

const objectivesSelectionOKService = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('objectivesSelectionOK'), requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error.body.errors);
        }
    );
};

const objectivesSelectionOK = (accessToken, callback) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };
        objectivesSelectionOKService(dispatch, requestData, callback);
    };
};

const initService = (dispatch, requestData, callback) => {
    const url = apiURLBuilder.getURL('init', {
        operationType: requestData.query.operationType,
    });
    Api.post(url, requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, data.data);
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const init = (operationType, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {
                operationType,
            },
        };

        initService(dispatch, saveRequestData, callback);
    };
};

const verifyPositionsService = (dispatch, requestData, callback) => {
    const url = apiURLBuilder.getURL('verifyPositions');
    Api.post(url, requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, data.data);
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const verifyPositions = (operationType, positionsValues, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {
                operationType,
                signaturePositionsValues: positionsValues,
            },
        };

        verifyPositionsService(dispatch, saveRequestData, callback);
    };
};

const verifyOTPService = (dispatch, requestData, callback) => {
    const url = apiURLBuilder.getURL('verifyOtp');
    Api.post(url, requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, data.data);
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const verifyOTP = (operationType, otpValue, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {
                operationType,
                signatureOtpValue: otpValue,
            },
        };

        verifyOTPService(dispatch, saveRequestData, callback);
    };
};

const updateEmailService = (dispatch, requestData, callback) => {
    const url = apiURLBuilder.getURL('updateEmail');
    Api.post(url, requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, data.data);
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const updateEmail = (newEmail, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {
                email: newEmail,
            },
        };

        updateEmailService(dispatch, saveRequestData, callback);
    };
};

const updateTelephoneService = (dispatch, requestData, callback) => {
    const url = apiURLBuilder.getURL('updateTelephone');
    Api.post(url, requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, data.data);
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const updateTelephone = (newTelephone, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {
                cellphone: newTelephone,
            },
        };

        updateTelephoneService(dispatch, saveRequestData, callback);
    };
};

const updateTelephoneServiceByEmail = (dispatch, requestData, callback) => {
    const url = apiURLBuilder.getURL('updateTelephoneByEmail');
    Api.post(url, requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, data.data);
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const updateTelephoneByEmail = (newTelephone, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {
                cellphone: newTelephone,
            },
        };

        updateTelephoneServiceByEmail(dispatch, saveRequestData, callback);
    };
};

const updateAddressService = (dispatch, requestData, callback) => {
    const url = apiURLBuilder.getURL('updateAddress');
    Api.post(url, requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, data.data);
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const updateAddress = (newAddress, accessToken, callback) => {
    return dispatch => {
        const request = {
            postalCode: newAddress[0].postalCode,
            town: newAddress[0].town,
            nameOfRoad: newAddress[0].nameOfRoad,
            addressNumber: newAddress[0].addressNumber,
            province: newAddress[0].province,
            additionalInfo: newAddress[0].additionalInfo,
            typeOfRoad: newAddress[0].typeOfRoad,
            country: newAddress[0].country,
        };
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {
                request,
            },
        };

        updateAddressService(dispatch, saveRequestData, callback);
    };
};

const validationAlreadyClientFailure = response => ({
    type: actionTypes.VALIDATION_DATA_ALREADY_CLIENT_FAILURE,
    payload: response,
});

const validationAlreadyClientSuccess = () => ({
    type: actionTypes.VALIDATION_DATA_ALREADY_CLIENT_SUCCESS,
});

const validationAlreadyClientRequest = () => ({
    type: actionTypes.VALIDATION_DATA_ALREADY_CLIENT_REQUEST,
});

const validationAlreadyClientReset = () => ({
    type: actionTypes.VALIDATION_DATA_ALREADY_CLIENT_RESET,
});

const validateSameDataAlreadyClientService = (dispatch, requestData, callback, operationType) => {
    const url = apiURLBuilder.getURL('validateSameData', {
        operationType,
    });
    Api.post(url, requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, data.data);
                dispatch(validationAlreadyClientSuccess());
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            if (error.body.status === 'Error') {
                dispatch(validationAlreadyClientFailure());
            }
        }
    );
};

const validateSameDataAlreadyClient = (operationType, data, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: data,
        };
        dispatch(validationAlreadyClientRequest());
        validateSameDataAlreadyClientService(dispatch, saveRequestData, callback, operationType);
    };
};

const getOnboardingInformationServiceByTokenPrivate = (
    dispatch,
    accessToken,
    professionalCategories,
    login = false,
    storage
) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    Api.get(apiURLBuilder.getURL('getOnboardingPrivate'), requestData).then(response => {
        if (response.body) {
            fillSteps(dispatch, response.body, professionalCategories, true, login, storage);
            dispatch({ type: 'HIDE_SPINNER' });
        }
    });
};

const getInformationServiceByTokenPrivate = (dispatch, token, professionalCategories, login = false, storage) => {
    const url = apiURLBuilder.getURL('getInformationByToken', { token });
    Api.get(url).then(
        response => {
            if (response.body) {
                const data = response.body;
                const expires = new Date(new Date().getTime() + 45 * 60 * 1000);

                if (data.accessToken) {
                    dispatch(formActions.change('userProfile.accessToken', data.accessToken));
                    if (ALLOW_COOKIE) {
                        Storage.cookies.set('accessToken', data.accessToken, {
                            expires,
                        });
                    }

                    if (data.refreshToken) {
                        dispatch(formActions.change('userProfile.refreshToken', data.refreshToken));
                        if (ALLOW_COOKIE) {
                            Storage.cookies.set('refreshToken', data.refreshToken, { expires });
                        }
                    }

                    getOnboardingInformationServiceByTokenPrivate(
                        dispatch,
                        data.accessToken,
                        professionalCategories,
                        login,
                        storage
                    );
                }
            }
        },
        () => {
            history.push(`${BASE_PATH}/errors`);
        }
    );
};

const getInformationByTokenPrivate = (token, professionalCategories, login = false, storage) => {
    return dispatch => {
        getInformationServiceByTokenPrivate(dispatch, token, professionalCategories, login, storage);
    };
};

const registerCreditCardService = async (dispatch, token) => {
    try {
        const requestData = {
            header: {
                Authorization: `Bearer ${token}`,
            },
        };

        const url = apiURLBuilder.getURL('creditCardRegister');
        const { body } = await Api.get(url, requestData);

        return body.status;
    } catch (error) {
        return error;
    }
};

const registerCreditCard = accessToken => {
    return async dispatch => {
        const response = await registerCreditCardService(dispatch, accessToken);

        return response;
    };
};

export default {
    changeCurrentStep,
    finalizeStep,
    finalizeSteps,
    enableStep,
    enableCurrentStep,
    disableFollowingStep,
    disablePreviousSteps,
    enablePreviousSteps,
    enableFinishedAndNextStep,
    savePersonalInformation,
    clientVerify,
    clientVerifyOk,
    clientFiocVerify,
    clientFiocAlta,
    getOnboardingInformation,
    getOnboardingInformationByToken,
    getInformationByToken,
    getInformationByTokenPrivate,
    resetStore,
    showWelcomeCard,
    hideWelcomeCard,
    selectDefaultSteps,
    selectAuthorizedSteps,
    selectClientSteps,
    selectConfigCardSteps,
    changeMinFinalizeStep,
    clientCardConfigVerify,
    selectRoboSteps,
    selectDepositSteps,
    selectGbiSteps,
    preDocumentationOk,
    init,
    verifyPositions,
    verifyOTP,
    updateEmail,
    updateTelephone,
    updateAddress,
    objectivesSelectionOK,
    updateTelephoneByEmail,
    validateSameDataAlreadyClient,
    validationAlreadyClientReset,
    selectCreditCardSteps,
    registerCreditCard,
};
